/**
 * The name of the bundled audio files which will be played for the laugh reaction sound.
 *
 * @type {Array<string>}
 */
export const LAUGH_SOUND_FILES = new Array(3).fill('reactions-laughter.mp3');
/**
 * The name of the bundled audio file which will be played for the clap reaction sound.
 *
 * @type {Array<string>}
 */
export const CLAP_SOUND_FILES = new Array(3).fill('reactions-applause.mp3');
/**
 * The name of the bundled audio file which will be played for the like reaction sound.
 *
 * @type {Array<string>}
 */
export const LIKE_SOUND_FILES = new Array(3).fill('reactions-thumbs-up.mp3');
/**
 * The name of the bundled audio file which will be played for the boo reaction sound.
 *
 * @type {Array<string>}
 */
export const BOO_SOUND_FILES = new Array(3).fill('reactions-boo.mp3');
/**
 * The name of the bundled audio file which will be played for the surprised reaction sound.
 *
 * @type {Array<string>}
 */
export const SURPRISE_SOUND_FILES = new Array(3).fill('reactions-surprise.mp3');
/**
 * The name of the bundled audio file which will be played for the silence reaction sound.
 *
 * @type {Array<string>}
 */
export const SILENCE_SOUND_FILES = new Array(3).fill('reactions-crickets.mp3');
/**
 * The name of the bundled audio file which will be played for the heart reaction sound.
 *
 * @type {Array<string>}
 */
export const HEART_SOUND_FILES = new Array(3).fill('reactions-love.mp3');
/**
 * The name of the bundled audio file which will be played for the raise hand sound.
 *
 * @type {string}
 */
export const RAISE_HAND_SOUND_FILE = 'reactions-raised-hand.mp3';
